import { useTranslation } from 'react-i18next';
import { statusEntry, toneStyle } from '@/components/vf/statusMap';
import type { LineState } from '@/services/dialer/callPage/lines';

/** One status map (D9): a line state always shows its icon and its label. */
const STATUS_KEY: Record<LineState, string> = {
  dialing: 'dialing', ringing: 'ringing', connected: 'connected_to_agent', voicemail: 'voicemail',
  no_answer: 'no_answer', failed: 'failed', cut: 'ended', unknown: 'unknown',
};

export function LineBadge({ state }: { state: LineState }) {
  const { t } = useTranslation(['dialer']);
  const entry = statusEntry(STATUS_KEY[state]);
  const style = toneStyle(entry.tone);
  const Icon = entry.icon;
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-semibold"
      style={{ color: style.fg, background: style.bg, borderColor: style.bd }}
    >
      <Icon className={`h-3 w-3 ${state === 'ringing' || state === 'dialing' ? 'vf-pulse' : ''}`} aria-hidden />
      {t(`dialer:callPage.lines.state.${state}`)}
    </span>
  );
}
